<template>
    <div id="app" v-cloak>
        <!-- pc -->
        <Pc v-if="isMobile === false" :language="language" @handleLang="handleLang"></Pc>
        <!-- 移动端 -->
        <Mobile v-if="isMobile === true" :language="language" @handleLang="handleLang"></Mobile>
    </div>
</template>

<script>
import Pc from '@/components/pc'
import Mobile from '@/components/mobile'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    data() {
        return {
            language: 'en',
            isMobile: null
        }
    },
    components: {
        Pc,
        Mobile
    },
    created() {
        window.location.href = 'https://store.habby.com/game/6?page=giftcode';
    },
    mounted() {
        this.init();
        this.initLANG();
        this.checkIfMobile();
        if (!this.isMobile) {
            this.adaptForPC();
        }
        if (parsed.clear) {
            localStorage.clear();
        }
    },
    methods: {
        initLANG() {
            let language = navigator.language.toLowerCase()
            if (parsed.gameLanguage) {
                language = parsed.gameLanguage
            }
            console.log(language, 'gameLanguage')
            if (language.startsWith('zh')) {
                if ('zh-cn' == language || 'zh-CN' == language || 'zh' == language) {
                    this.language = 'en'
                } else {
                    this.language = 'zh-TW'
                }
            } else if (language.startsWith('ja')) {
                this.language = 'ja'
            } else if (language.startsWith('ko')) {
                this.language = 'ko'
            }  else {
                this.language = 'en'
            }
        },
        handleLang(val){
            this.language = val;
        },
        // 区分移动还是pc
        checkIfMobile() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            this.isMobile = /android|webos|iphone|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        },
        // PC端适配函数
        adaptForPC() {
            // 基准宽度，设计稿的宽度
            const baseWidth = 1920;
            // 获取当前窗口宽度
            const currentWidth = window.innerWidth;
            // 计算缩放比例
            const scale = currentWidth / baseWidth;
            
            // 设置根元素字体大小，用于rem适配
            document.documentElement.style.fontSize = `${16 * scale}px`;
            
            // 监听窗口大小变化，动态调整
            window.addEventListener('resize', () => {
                const newWidth = window.innerWidth;
                const newScale = newWidth / baseWidth;
                document.documentElement.style.fontSize = `${16 * newScale}px`;
                
                // 针对特定宽度范围的额外适配
                if (newWidth < 1200) {
                    // 小屏幕PC的特殊处理
                    document.body.classList.add('small-screen');
                } else if (newWidth >= 1200 && newWidth < 1600) {
                    // 中等屏幕PC的特殊处理
                    document.body.classList.remove('small-screen');
                    document.body.classList.add('medium-screen');
                } else {                   // 大屏幕PC的特殊处理
                    document.body.classList.remove('small-screen');
                    document.body.classList.remove('medium-screen');
                }
            });
            
            // 初始化时执行一次屏幕尺寸检测
            if (currentWidth < 1200) {
                document.body.classList.add('small-screen');
            } else if (currentWidth >= 1200 && currentWidth < 1600) {
                document.body.classList.add('medium-screen');
            }
        },
        init() {
            // 禁止双指放大 
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
        },
    }
}
</script>

<style lang="less">
@import '../static/fonts/fonts.css';
html,
body {
    min-height: 100%;
    text-align: center;
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0;
    padding: 0;
}
img {
    border: none;
    vertical-align: middle;
    user-select: none; /* 禁止选中 */
}

a {
    text-decoration: none;
    color: #232323;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
.el-scrollbar {
    .el-scrollbar__bar {
        opacity: 1 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue